module.exports = __webpack_public_path__ + "img/front _closure_length.96b86847.png";